'use client';
import dynamic from 'next/dynamic';

const KlantenkaartHome = dynamic(
    () => import('./KlantenkaartHome'),
    { ssr: false }
);

export default function KlantenkaartHomeWrapper() {
    return <KlantenkaartHome />;
}
